<template>
    <el-dialog  title="Upsell"
        :visible.sync="showForm"
        append-to-body
        :close-on-click-modal="false">

        <el-form label-position="top" v-loading="loading">
            <el-form-item label="Name">
                <el-input v-model="formData.name"></el-input>
            </el-form-item>

            <h2>Basis:</h2>

            <el-form-item label="Basis Month">
                <el-date-picker v-model="formData.basis_from" type="date"></el-date-picker>
            </el-form-item>

            <el-form-item label="High-Water Mark Basis">
                <el-input v-model="formData.high_water_mark_basis"></el-input>
            </el-form-item>

            <el-form-item label="Net Invoice">
                <el-input v-model="formData.net_invoice"></el-input>
            </el-form-item>

            <el-form-item label="Upsell">
                <el-input v-model="formData.upsell"></el-input>
            </el-form-item>

            <h2>Commission:</h2>

            <el-form-item label="Commission Month">
                <el-date-picker v-model="formData.eligible_from" type="date"></el-date-picker>
            </el-form-item>

            <el-form-item label="Eligible Commission">
                <el-input v-model="formData.eligible_commission"></el-input>
            </el-form-item>

            <el-form-item label="Months Remaining">
                <el-input-number v-model="formData.months_remaining" :min="0" :max="12"></el-input-number>
            </el-form-item>

            <el-form-item label="Upsell Commission">
                <el-input v-model="formData.upsell_commission"></el-input>
            </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="showForm = false">Close</el-button>
            <el-button type="primary" @click="save()">Save</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
        props: [
            'show',
            'data_id',
            'employer_id',
        ],
        data() {
            return {
                formData: {},
                loading: true
            };
        },
        watch: {
            show() {
                if (this.show) {
                    this.refresh();
                }
            }
        },
        computed: {
            showForm: {
                get() { return this.show; },
                set(val) { this.$emit('close'); }
            }
        },
        methods: {
            refresh() {
                if (this.data_id) {
                    this.loading = true;
                    axios.get(url(`admin/upsell/${this.data_id}/detail`))
                    .then((response) => {
                        this.formData = response.data;
                        this.loading = false;
                    });
                } else {
                    this.formData = {
                        id: this.data_id,
                        name: '',
                        basis_from: '',
                        eligible_from: '',
                        high_water_mark_basis: '',
                        upsell: '',
                        net_invoice: '',
                        eligible_commission: '',
                        months_remaining: 12,
                        upsell_commission: ''
                    }
                    this.loading = false;
                }
                
            },
            save() {
                if (this.formData.id) {
                    this.update();
                } else {
                    this.create();
                }
            },
            update() {
                return axios.post(url(`admin/upsell/${this.data_id}/update`), {
                    data: this.formData,
                }).then(() => {
                    this.$message.success('Upsell updated');
                    this.showForm = false;
                    this.$emit('updated');
                });
            },
            create() {
                return axios.post(url(`admin/employer/${this.employer_id}/upsell/create`), {
                    data: this.formData,
                }).then(() => {
                    this.$message.success('Upsell created');
                    this.showForm = false;
                    this.$emit('updated');
                });
            }
        },
    }
</script>

<style scoped>
    h2 {
        margin-top: 50px;
    }
</style>
